import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createRouter, createWebHistory, START_LOCATION } from 'vue-router';
import i18n from '../i18n';
import App from './App.vue';
import RouteSingle from '../schedules/pages/RouteSingle.vue';
import RouteStop from '../schedules/pages/RouteStop.vue';
import StopSingle from '../schedules/pages/StopSingle.vue';

const app = createApp(App);
const pinia = createPinia();

const basePath = document.documentElement.lang === 'en'
    ? '/en/schedules-and-routes/bus-schedule/all-routes'
    : '/horaires-et-trajets/horaires-des-bus/tous-les-parcours';

const routes = [
    {
        name: 'stop-single',
        path: `${basePath}/:stop(\\d{4}.*?)/:date(\\d{4}-\\d{2}-\\d{2})?`,
        component: StopSingle,
    },
    {
        name: 'route-single',
        path: `${basePath}/:route(\\d{1,3}[A-Z]?)/:direction?/:date(\\d{4}-\\d{2}-\\d{2})?`,
        component: RouteSingle,
    },
    {
        name: 'route-stop',
        path: `${basePath}/:route(\\d{1,4}[A-Z]?)/:direction/:stop(\\d{4}.*)/:date(\\d{4}-\\d{2}-\\d{2})?`,
        component: RouteStop,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from) => {
    if (from !== START_LOCATION) {
        window.location.href = to.fullPath;
        return false;
    }
});

app.use(i18n);
app.use(pinia);
app.use(router);
app.mount('#vue-home-route-selector');
